








































































import Vue from "vue";
import statusQuery from "@/common/mixins/statusQuery";
import pagination from "@/common/mixins/pagination";
import FilterErrorTracking from "../components/FilterErrorTracking.vue";
import { ErrorTrackingIncorrectInventory } from "../models/ErrorTrackingIncorrectInventory";
import {
  ErrorTrackingIncorrectInventoryForm,
  ErrorTrackingStatus
} from "../forms/ErrorTrackingIncorrectInventoryForm";
export default Vue.extend({
  mixins: [pagination, statusQuery],
  components: {
    FilterErrorTracking
  },
  data() {
    const incorrectInventories: ErrorTrackingIncorrectInventory[] = [];
    const errorTrackingIncorrectInventoryForm: ErrorTrackingIncorrectInventoryForm = {
      page: (this as any).currentPage,
      perPage: (this as any).perPage,
      status: undefined
    };
    const isLoading = false;
    return {
      isLoading,
      incorrectInventories,
      errorTrackingIncorrectInventoryForm
    };
  },
  async created() {
    this.isLoading = true;
    (this as any).getPaginationRouteQuery();
    (this as any).getStatusRouteQuery();
    this.setReportFilterForm();
    await this.getIncorrectInventories();
    this.isLoading = false;
  },
  watch: {
    async "$route.query"() {
      this.setReportFilterForm();
      await this.getIncorrectInventories();
    }
  },
  methods: {
    setReportFilterForm() {
      this.errorTrackingIncorrectInventoryForm = {
        ...this.errorTrackingIncorrectInventoryForm,
        page: (this as any).currentPage,
        status: (this as any).status ? (this as any).status : undefined
      };
    },
    async getIncorrectInventories() {
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.errorTrackingUseCase.getErrorTrackingIncorrectInnventory(
          this.errorTrackingIncorrectInventoryForm
        );
        this.incorrectInventories = data;

        (this as any).setPaginationMeta(meta);
        (this as any).setStatusQuery(
          this.errorTrackingIncorrectInventoryForm.status
        );
      } catch (error) {
        console.log(error);
      }
    },
    async changeStatusOption(option: string) {
      this.isLoading = true;
      if (option == "") {
        this.errorTrackingIncorrectInventoryForm = {
          ...this.errorTrackingIncorrectInventoryForm,
          status: undefined
        };
      } else if (option == ErrorTrackingStatus.WAIT) {
        this.errorTrackingIncorrectInventoryForm = {
          ...this.errorTrackingIncorrectInventoryForm,
          status: ErrorTrackingStatus.WAIT
        };
      } else if (option == ErrorTrackingStatus.FIXING) {
        this.errorTrackingIncorrectInventoryForm = {
          ...this.errorTrackingIncorrectInventoryForm,
          status: ErrorTrackingStatus.FIXING
        };
      } else if (option == ErrorTrackingStatus.FIXED) {
        this.errorTrackingIncorrectInventoryForm = {
          ...this.errorTrackingIncorrectInventoryForm,
          status: ErrorTrackingStatus.FIXED
        };
      }

      await this.getIncorrectInventories();
      this.isLoading = false;
    },
    goToIncorrectInventoryDetailPage(id: any) {
      this.$router.push({
        name: "ErrorTrackingIncorrectInventoryDetailPage",
        params: { id }
      });
    }
  }
});
